module.exports = __webpack_public_path__ + "static/media/cart-icon.5fa77433.svg";